import { Component, computed, inject } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { DrawerModule } from 'primeng/drawer';
import { AvatarModule } from 'primeng/avatar';
import { TagModule } from 'primeng/tag';
import { LayoutService } from '@/layout/service/layout.service';
import { UserService } from '@/services/user.service';
import { isTestEnvironment } from '@/config/environment.config';
import { APP_VERSION } from '@/version';

@Component({
    selector: '[app-profilesidebar]',
    imports: [ButtonModule, DrawerModule, AvatarModule, TagModule],
    template: `
        <p-drawer [visible]="visible()" (onHide)="onDrawerHide()" position="right" [transitionOptions]="'.3s cubic-bezier(0, 0, 0.2, 1)'" styleClass="layout-profile-sidebar">
            <ng-template #headless>
                <div class="profile-header">
                    <p-avatar [label]="userService.initials" shape="circle" size="xlarge" styleClass="profile-avatar" />
                    <div class="flex flex-col min-w-0 flex-1">
                        <span class="profile-name truncate">{{ userService.displayName }}</span>
                        @if (userService.email) {
                            <span class="profile-subtitle truncate">{{ userService.email }}</span>
                        } @else if (userService.username) {
                            <span class="profile-subtitle truncate">{{ userService.username }}</span>
                        }
                    </div>
                    <p-button icon="pi pi-times" [text]="true" [rounded]="true" styleClass="profile-close" (onClick)="onDrawerHide()" ariaLabel="Schliessen" />
                </div>

                <div class="profile-body">
                    <span class="profile-section-title">Konto</span>
                    <ul class="profile-list">
                        @if (userService.username) {
                            <li>
                                <i class="pi pi-user"></i>
                                <span class="profile-list-label">Benutzer</span>
                                <span class="profile-list-value">{{ userService.username }}</span>
                            </li>
                        }
                        @if (groups.length) {
                            <li>
                                <i class="pi pi-users"></i>
                                <span class="profile-list-label">Gruppe</span>
                                <span class="profile-list-value flex flex-wrap gap-1">
                                    @for (group of groups; track group) {
                                        <p-tag [value]="group" severity="secondary" />
                                    }
                                </span>
                            </li>
                        }
                        @if (userService.email) {
                            <li>
                                <i class="pi pi-envelope"></i>
                                <span class="profile-list-label">E-Mail</span>
                                <span class="profile-list-value">{{ userService.email }}</span>
                            </li>
                        }
                        <li>
                            <i class="pi pi-server"></i>
                            <span class="profile-list-label">Umgebung</span>
                            <span class="profile-list-value">
                                @if (isTest) {
                                    <p-tag value="Testumgebung" severity="warn" />
                                } @else {
                                    <p-tag value="Produktion" severity="success" />
                                }
                            </span>
                        </li>
                    </ul>

                    <p-button label="Abmelden" icon="pi pi-sign-out" severity="danger" [outlined]="true" styleClass="w-full" (onClick)="userService.logout()" />
                </div>

                <div class="profile-footer">
                    <span>CenazeFon Admin</span>
                    <span>v{{ appVersion }}</span>
                </div>
            </ng-template>
        </p-drawer>
    `
})
export class AppProfileSidebar {
    readonly userService = inject(UserService);
    readonly groups = this.userService.groups;
    readonly appVersion = APP_VERSION;
    readonly isTest = isTestEnvironment();

    constructor(public layoutService: LayoutService) {}

    visible = computed(() => this.layoutService.layoutState().profileSidebarVisible);

    onDrawerHide() {
        this.layoutService.layoutState.update((state) => ({
            ...state,
            profileSidebarVisible: false
        }));
    }
}
